'use strict';

/**
 * Get selected charm products
 * @return {string[]} - List of selected bundle product item ID's
 */
function getCharmProducts() {
    var charmProducts = [];
    $('.modify-charm-modal .select-charm:checked').each(function () {
        charmProducts.push({
            pid: $(this).data().charmId,
            quantity: parseInt($(this).data().quantity, 10),
        });
    });

    return charmProducts.length ? JSON.stringify(charmProducts) : [];
}

/**
 * Calculates the total quantity of selected charms.
 * @param {jQuery} $charmWrapper - A jQuery element that contains charm items.
 * @returns {number} The total quantity of selected charms.
 */
function getCharmsTotalPrice($charmWrapper) {
    const selectedCharms = $('.select-charm:checked', $charmWrapper);
    let totalPrice = 0;
    selectedCharms.each(function () {
        const $this = $(this);
        const charmQty = parseInt($this.data().quantity, 10);
        const charmPrice = $this.data().priceValue;
        totalPrice += charmPrice * charmQty;
    });
    return totalPrice;
}

/**
 * Calculates the total quantity of selected charms within the given wrapper element.
 * @param {jQuery} $charmWrapper - A jQuery element that contains charm items.
 * @returns {number} The total quantity of selected charms.
 */
function getCharmsTotalQty($charmWrapper) {
    const selectedCharms = $('.select-charm:checked', $charmWrapper);
    let totalQty = 0;
    selectedCharms.each(function () {
        const charmVal = parseInt($(this).data().quantity, 10);
        totalQty += charmVal;
    });
    return totalQty;
}

/**
 * Updates the charm selection state and UI based on the total quantity of selected charms.
 * @param {jQuery} $charmWrapper - A jQuery element that contains charm items.
 */
function updatedAllCharms($charmWrapper) {
    $('.modify-charm-modal .error-text').addClass('d-none');
    $charmWrapper.each(function () {
        const $this = $(this);
        const totalQty = getCharmsTotalQty($this);
        const totalPrice = getCharmsTotalPrice($this);
        const currency = $('.select-charm', $this).first().data().priceCurrency;
        const maxLimit = parseInt($('.charms-container', $this).data().limit, 10);
        $('.select-charm', $this)
            .removeClass('selected')
            .prop('disabled', totalQty >= maxLimit);
        if (totalQty < maxLimit) {
            $('.select-charm:checked', $this).addClass('selected').prop('disabled', true);
        }
        $('.charm-footer', $this).toggleClass('active', totalQty > 0);
        $('.submit-charms .charm-price-total', $this).text(totalPrice);
        $('.submit-charms .charm-currency', $this).text(currency);
    });
}
/**
 * Loop through each charm item to collect selected charms and their quantities
 * @param {jQuery} $thisWrapper - A jQuery element that contains charm items.
 * @param {jQuery} $charmImages - A jQuery element that is container of images
 */
function updateCharmData($thisWrapper, $charmImages) {
    $charmImages.empty();
    let isCharmSelected = false;
    $('.select-charm:checked', $thisWrapper).each(function () {
        const $thisInnter = $(this);
        const charmQty = parseInt($thisInnter.data().quantity, 10);
        if (charmQty > 0) {
            isCharmSelected = true;
            const imageEle = $thisInnter.closest('.charm-item').find('img')[0];
            if (imageEle) {
                $charmImages.append(imageEle.outerHTML);
            }
        }
    });
    if (isCharmSelected) {
        let $charmAttr = $charmImages.closest('.attribute-charm');
        if ($charmAttr.length) {
            $charmAttr.addClass('selected');
            const currency = $('.charm-currency', $thisWrapper).text();
            const price = $('.charm-price-total', $thisWrapper).text();
            $charmAttr.find('.selected-value').text(`+${currency}${price}`);
        }
    }
}

/**
 * Initializes event listeners for charms and updates the quantity logic.
 */
module.exports = {
    init: function () {
        // Handle checkbox change to toggle quantity input and visibility
        updatedAllCharms($('.charm-popuop-wrapper'));
        if ($('.attribute-charm').length) {
            parseInt($('.attribute-charm').data().limit, 10);
        }
        $(document).on('change', '.select-charm', function (e) {
            e.preventDefault();
            const $this = $(this);
            const $thisWrapper = $this.closest('.charm-popuop-wrapper');
            if (!$this.hasClass('.charm-item-sold-out')) {
                let charmVal = parseInt($this.data().quantity, 10);
                if (charmVal === 0) {
                    charmVal = 1;
                    $this.data('quantity', 1);
                }
                $this.closest('.charm-item').find('.selected-quantity').text(charmVal);
                updatedAllCharms($thisWrapper);
                const charmTitle = $this.data().title;
                if (charmTitle) {
                    $('.charm-title', $thisWrapper).text(charmTitle);
                }
            }
        });

        // Handle quantity increase (plus button)
        $(document).on('click', '.add.edit-quantity', function (e) {
            e.preventDefault();
            const totalQty = getCharmsTotalQty();
            const $this = $(this);
            const $thisWrapper = $this.closest('.charm-popuop-wrapper');
            const maxLimit = parseInt($('.charms-container', $thisWrapper).data().limit, 10);
            if (totalQty < maxLimit) {
                const $charmInput = $this.closest('.charm-item').find('.select-charm');
                let currentQuantity = parseInt($charmInput.data().quantity, 10);
                currentQuantity += 1;
                $charmInput.data('quantity', currentQuantity);
                $(this).closest('.charm-item').find('.selected-quantity').text(currentQuantity);
                updatedAllCharms($thisWrapper);
                const charmTitle = $charmInput.data().title;
                if (charmTitle) {
                    $('.charm-title', $thisWrapper).text(charmTitle);
                }
            }
        });

        // Handle quantity decrease (minus button)
        $(document).on('click', '.remove.edit-quantity', function (e) {
            e.preventDefault();
            const $this = $(this);
            const $charmInput = $this.closest('.charm-item').find('.select-charm');
            let currentQuantity = parseInt($charmInput.data().quantity, 10);
            const $thisWrapper = $this.closest('.charm-popuop-wrapper');

            if (currentQuantity > 0) {
                currentQuantity -= 1;
                $charmInput.data('quantity', currentQuantity);
                // If quantity reaches 0, uncheck the checkbox and hide charm-quantity-wrapper
                const charmTitle = $charmInput.data().title;
                if (currentQuantity === 0) {
                    $this.closest('.charm-item').find('.select-charm').prop('checked', false);
                    $('.charm-title', $thisWrapper).text('');
                } else if (charmTitle) {
                    $('.charm-title', $thisWrapper).text(charmTitle);
                }
                $this.closest('.charm-item').find('.selected-quantity').text(currentQuantity);
                updatedAllCharms($thisWrapper);
            }
        });

        // Handle Submit Button click
        $(document).on('click', '.submit-charms', function (e) {
            e.preventDefault();
            const $this = $(this);
            const $thisWrapper = $this.closest('.charm-popuop-wrapper');
            const $charmImages = $('.charms-images-' + $this.data().id);
            if (!$this.closest('.modify-charm-modal').length) {
                const $addToCart = $('.charms-slider-opener').first().siblings('.add-to-cart');
                if ($addToCart.data() && $addToCart.data().readyToOrder) {
                    $addToCart.removeClass('d-none');
                    $('.charms-slider-opener').addClass('d-none');
                }
                updateCharmData($thisWrapper, $charmImages);
            } else {
                const url = $this.data('url');
                const uuid = $this.data('id');
                $('.modify-charm-modal').spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    data: {
                        uuid: uuid,
                        charmProducts: getCharmProducts(),
                        charmUpdate: true,
                    },
                    success: function (data) {
                        if (data.error) {
                            $('.modify-charm-modal .error-text').removeClass('d-none').text(data.message);
                            $('.modify-charm-modal').spinner().stop();
                        } else {
                            window.location.reload();
                        }
                    },
                });
            }
        });

        $(document).on('click', '.modify-personalization-link', function (e) {
            e.preventDefault();
            const $this = $(this);
            const uuid = $this.data('uuid');
            const url = $this.attr('href');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                data: {
                    uuid: uuid,
                },
                success: function (responce) {
                    $('.modify-charm-modal').remove();
                    $('body').append(responce);
                    const $modifyModal = $('.modify-charm-modal');
                    $modifyModal.modal('show');
                    updatedAllCharms($modifyModal);
                    $.spinner().stop();
                },
            });
        });
    },
};
